(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_c79b271"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('landing-frame-video')) {
    class LandingFrameVideo extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.handleChange = () => this.mount();
        this.mobileQuery.addEventListener('change', this.handleChange);
        this.mount();
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.handleChange);
      }

      mount() {
        const key = this.mobileQuery.matches ? 'mobile' : 'desktop';
        const template =
          this.querySelector(`template[data-video="${key}"]`) || this.querySelector('template[data-video="all"]');
        if (!template || template === this.activeTemplate) return;

        const video = template.content.querySelector('video')?.cloneNode(true);
        if (!video) return;

        this.querySelector('video')?.remove();
        this.classList.remove('is-playing');
        this.activeTemplate = template;

        video.muted = true;
        video.playsInline = true;
        video.setAttribute('aria-hidden', 'true');
        video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
        this.appendChild(video);
        video.play()?.catch(() => {});
      }
    }
    customElements.define('landing-frame-video', LandingFrameVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
